// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1tEPS","alert":"SettungsInbox_alert__1l3nZ"};